const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'discount_bubble_membership',
    modelClass: Backbone.Model,
    viewClass: require('./view'),
});
